import React, { useState } from "react";
import {
  Modal,
  Button,
  Spinner,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";

import axiosInstance from "../../../_helpers/axiosConfig";

function handleApptDecision(action, reload, token, show, loading) {
  let decision = {};

  switch (action) {
    case "accept":
      decision = { action: "accept" };
      break;
    case "waitlist":
      decision = { action: "reject", reject: "keep" };
      break;
    case "remove":
      decision = { action: "reject", reject: "remove" };
      break;
    default:
  }
  axiosInstance
    .request({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/vaccine/appointment/${token}`,
      data: decision,
    })
    .then((response) => {
      show(false);
      reload();
      loading(false);
    })
    .catch((error) => {
      loading(false);
      alert("Something went wrong. Please check your internet and try again.");
    });
}

export default function PendingActions(props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState("");

  return (
    <div>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="text-capitalize">{action}</span>&nbsp;Appointment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you would like to {action} this appointment?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);
              handleApptDecision(
                action,
                props.reload,
                props.data.token,
                setShowConfirm,
                setLoading
              );
            }}
          >
            {loading ? <Spinner size="sm" animation="border"></Spinner> : "Yes"}
          </Button>
          <Button disabled={loading} onClick={() => setShowConfirm(false)}>Cancel</Button>
        </Modal.Footer>
      </Modal>
      <div className="row">
        <div className="col p-0">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => {
              setAction("accept");
              setShowConfirm(true);
            }}
          >
            Accept
          </Button>
        </div>
        <div className="col">
          <DropdownButton
            drop="left"
            title="Reject"
            size="sm"
            variant="outline-primary"
          >
            <Dropdown.Item
              onClick={() => {
                setAction("waitlist");
                setShowConfirm(true);
              }}
            >
              Keep
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setAction("remove");
                setShowConfirm(true);
              }}
            >
              Remove
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </div>
    </div>
  );
}
